export function normalizeBirthdayItems(items) {
  return (Array.isArray(items) ? items : [])
    .map((item) => ({
      id: item?.id ?? null,
      name: item?.name ?? "",
      age: Number(item?.age_to_complete ?? 0),
      roleLabel: item?.role_label ?? "",
      dateLabel: item?.date_label ?? "",
    }))
    .filter((item) => item.id && item.name)
    .sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));
}
